<div class="inbox-datatable__main-content scrollable-component">
	<div class="inbox-filter__content mb-1">
		<div class="filter">
			<cv-input
				[label]="'Transaction'"
				[type]="'search'"
				[placeholder]="'Transaction ID'"
				[value]="filterLogs.transactionId"
				[maxlength]="100"
				(textCleared)="onFiltersChange('transactionId', $event)"
				(controlKeyup)="onFiltersChange('transactionId', $event)">
			</cv-input>
		</div>
		<div class="filter" *ngIf="origin === 'Nexsys Legacy'">
			<cv-input
				[label]="'Provider Order Identifier'"
				[type]="'search'"
				[placeholder]="'Provider Order Identifier'"
				[value]="filterLogs.providerOrderIdentifier"
				[maxlength]="100"
				(textCleared)="onFiltersChange('providerOrderIdentifier', $event)"
				(controlKeyup)="onFiltersChange('providerOrderIdentifier', $event)"
				>
			</cv-input>
		</div>
		<div class="filter" *ngIf="origin === 'Nexsys'">
			<cv-input
				[label]="sourceInputText"
				[type]="'search'"
				[placeholder]="sourceInputText"
				[value]="filterLogs.nexsysOrderId"
				[maxlength]="100"
				(textCleared)="onFiltersChange('nexsysOrderId', $event)"
				(controlKeyup)="onFiltersChange('nexsysOrderId', $event)">
			</cv-input>
		</div>
		<div class="filter" *ngIf="origin === 'FNC'">
			<cv-input
				[label]="sourceInputText"
				[type]="'search'"
				[placeholder]="sourceInputText"
				[value]="filterLogs.nexsysOrderId"
				[maxlength]="100"
				(textCleared)="onFiltersChange('fncOrderId', $event)"
				(controlKeyup)="onFiltersChange('fncOrderId', $event)">
			</cv-input>
		</div>
		<div class="filter" *ngIf="origin ==='Valuelink'">
			<cv-input
				[label]="sourceInputText"
				[type]="'search'"
				[placeholder]="sourceInputText"
				[value]="filterLogs.ValueLinkOrderId"
				[maxlength]="100"
				(textCleared)="onFiltersChange('ValueLinkOrderId', $event)"
				(controlKeyup)="onFiltersChange('ValueLinkOrderId', $event)">
			</cv-input>
		</div>
		<div class="filter" *ngIf="origin ==='Connexions'">
			<cv-input
				[label]="sourceInputText"
				[type]="'search'"
				[placeholder]="sourceInputText"
				[value]="filterLogs.ConnexionsOrderId"
				[maxlength]="100"
				(textCleared)="onFiltersChange('ConnexionsOrderId', $event)"
				(controlKeyup)="onFiltersChange('ConnexionsOrderId', $event)">
			</cv-input>
		</div>
		<div class="filter" *ngIf="origin === 'Xpanse'">
			<cv-input
				[label]="'Xpanse SPN ID'"
				[type]="'search'"
				[placeholder]="'Xpanse SPN ID'"
				[value]="filterLogs.xpanseSPNId"
				[maxlength]="100"
				(textCleared)="onFiltersChange('xpanseSPNId', $event)"
				(controlKeyup)="onFiltersChange('xpanseSPNId', $event)">
			</cv-input>
		</div>
		<div class="filter" *ngIf="origin === 'Xpanse'">
			<cv-input
				[label]="'Xpanse Transaction Id'"
				[type]="'search'"
				[placeholder]="'Xpanse Transaction Id'"
				[value]="filterLogs.xpanseTransactionId"
				[maxlength]="100"
				(textCleared)="onFiltersChange('xpanseTransactionId', $event)"
				(controlKeyup)="onFiltersChange('xpanseTransactionId', $event)">
			</cv-input>
		</div>
		<div class="filter" *ngIf="origin ==='Order External'">
			<cv-input
				[label]="'Client Id'"
				[type]="'search'"
				[placeholder]="'Client Id'"
				[value]="filterLogs.clientId"
				[maxlength]="100"
				(textCleared)="onFiltersChange('clientId', $event)"
				(controlKeyup)="onFiltersChange('clientId', $event)">
			</cv-input>
		</div>
		<div class="filter" *ngIf="origin ==='LendingQb'" >
			<cv-input
				[label]="'Lending QB Order ID'"
				[type]="'search'"
				[placeholder]="'Lending QB Order ID'"
				[value]="filterLogs.lendingQbOrderId"
				[maxlength]="100"
				(textCleared)="onFiltersChange('lendingQbOrderId', $event)"
				(controlKeyup)="onFiltersChange('lendingQbOrderId', $event)"
				>
			</cv-input>
		</div>
		<ng-container *ngIf="origin ==='Fics'">
			<div class="filter">
				<cv-input
					[label]="'FICS Order ID'"
					[type]="'search'"
					[placeholder]="'FICS Order ID'"
					[value]="filterLogs.ficsOrderId"
					[maxlength]="100"
					(textCleared)="onFiltersChange('ficsOrderId', $event)"
					(controlKeyup)="onFiltersChange('ficsOrderId', $event)"
					>
				</cv-input>
			</div>
			<div class="filter">
				<cv-input
					[label]="'FICS Vendor Indetifier'"
					[type]="'search'"
					[placeholder]="'FICS Vendor Indetifier'"
					[value]="filterLogs.vendorOrderIdentifier"
					[maxlength]="100"
					(textCleared)="onFiltersChange('vendorOrderIdentifier', $event)"
					(controlKeyup)="onFiltersChange('vendorOrderIdentifier', $event)"
					>
				</cv-input>
			</div>
		</ng-container>

		<div class="filter"
			*ngIf="origin !=='Nexsys Legacy'
				&& origin !=='Connexions'
				&& origin !=='LendingQb'"
		>
			<cv-input
				[label]="'Class Order Id'"
				[type]="'search'"
				[placeholder]="'Class Order ID'"
				[value]="filterLogs.classOrderId"
				[maxlength]="100"
				(textCleared)="onFiltersChange('classOrderId', $event)"
				(controlKeyup)="onFiltersChange('classOrderId', $event)"
				>
			</cv-input>
		</div>

		<div class="filter">
			<cv-input
				[label]="'Event Name'"
				[type]="'search'"
				[placeholder]="'Event Name'"
				[value]="filterLogs.eventName"
				[maxlength]="100"
				(textCleared)="onFiltersChange('eventName', $event)"
				(controlKeyup)="onFiltersChange('eventName', $event)">
			</cv-input>
		</div>

		<div class="filter" *ngIf="origin === 'Nexsys Legacy'">
			<cv-dropdown
				[label]="'Show read'"
				[placeholder]="'Read'"
				[options]="isReadFilterOptions"
				[width]="'300px'"
				[optionText]="'name'"
				[selectedValue]="filterLogs.read"
				(valuesChange)="onFiltersChange('read', $event)"
			></cv-dropdown>
		</div>
		<div class="filter_search">
			<button class="btn btn-sm cv-btn-blue" (click)="onSearchLog()">
				<i class="fas fa-search"></i>
			</button>
		</div>
	</div>
	<div class="mb-3">
		<button class="btn-link btn btn-sm"
						(click)="clearAllFilters()">
			<i class="fa fa-trash mr-1"></i>
			clear filters
		</button>
	</div>
	<ag-grid-angular
		#grid
		class="ag-theme-balham"
		[enableCellTextSelection]="true"
		[style.height.px]="gridHeight"
		[style.max-height.vh]="59"
		(gridReady)="onInitializeGrid($event)"
		(gridSizeChanged)="resizeToFitColumns()"
		[pagination]="false"
		[suppressPaginationPanel]="true"
		[gridOptions]="gridOptions"
		[domLayout]="'normal'"
		[rowData]="gridData"
		(selectionChanged)="onSelectionChanged()"
	>
	</ag-grid-angular>
	<div class="filter-input text-right">
		<cv-input
			[displayMode]="'inline'"
			[label]="'Limit'"
			[placeholder]="'Limit'"
			[type]="'number'"
			[value]="filterLogs.limit"
			[maxlength]="2"
			[min]="0"
			(controlChange)="onFiltersChange('limit', $event)"
			(controlKeyup)="onFiltersChange('limit', $event)"
		>
		</cv-input>
	</div>
</div>
